const zIndexes = {
  OpaqueLayer: 10,
  AuthModal: 20,
  Toolbar: 10,
  Popup: 60,
  WriteFooter: 10,
  PublishScreen: 15,
  DragDropUpload: 100,
};

export default zIndexes;
